import { useId } from 'react';
import { WeeklyPaceSkillSource } from '../../../graphQLOperations/__generated__/DashboardGetWeeklySnapshotQuery.graphql';

interface Props {
  source: WeeklyPaceSkillSource;
  onChange: (source: WeeklyPaceSkillSource) => void;
}

// Listed explicitly rather than derived from the generated enum, which carries Relay's
// "%future added value" member for server-side additions this UI has no label for.
const SOURCE_OPTIONS: ReadonlyArray<{ value: WeeklyPaceSkillSource; label: string }> = [
  { value: 'DEMONSTRATED', label: 'Demonstrated' },
  { value: 'DIRECTLY_PASSED', label: 'Directly passed' },
];

export const WeeklyPaceSourceToggle = ({ source, onChange }: Props): JSX.Element => {
  const groupLabelId = useId();

  return (
    <div className="tw-h-fit">
      <h3 id={groupLabelId} className="tw-sr-only">
        Count skills reached by
      </h3>
      <div
        role="radiogroup"
        aria-labelledby={groupLabelId}
        className="tw-flex tw-items-center tw-gap-1 tw-rounded-full tw-border-2 tw-border-solid tw-border-neutral-100 tw-bg-neutral-50 tw-p-1"
      >
        {SOURCE_OPTIONS.map(option => {
          const isSelected = option.value === source;

          return (
            <button
              key={option.value}
              // Shared by both options on purpose: PostHog groups the clicks under the one id and
              // the button's own text says which source was picked.
              id="paceCountToggle"
              type="button"
              role="radio"
              aria-checked={isSelected}
              onClick={() => onChange(option.value)}
              className={`tw-flex tw-cursor-pointer tw-items-center tw-rounded-full tw-border-2 tw-border-solid tw-px-3 tw-py-1 ${
                isSelected
                  ? 'tw-border-neutral-100 tw-bg-neutral-0 tw-shadow-[0px_0px_10px_0px_rgba(132,123,111,0.1)]'
                  : 'tw-border-transparent tw-bg-transparent'
              }`}
            >
              <span
                className={`tw-whitespace-nowrap tw-font-atkinson tw-text-sm tw-font-bold ${
                  isSelected ? 'tw-text-indigo-600' : 'tw-text-neutral-700'
                }`}
              >
                {option.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
